import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { httpClient } from '../../../shared/api/httpClient'

async function fetchMenemosineAudits(filters) {
  const response = await httpClient.get('/menemosine/audit', { params: filters })
  return response.data
}

export function useMenemosineQuery() {
  const [filters, setFilters] = useState(null)

  const query = useQuery({
    queryKey: ['menemosineAudits', filters],
    queryFn: () => fetchMenemosineAudits(filters),
    enabled: filters !== null,
  })

  return {
    audits: query.data ?? [],
    isLoading: query.isFetching,
    isError: query.isError,
    error: query.error,
    search: setFilters,
  }
}

async function fetchMenemosineAuditDetail(id) {
  const response = await httpClient.get(`/menemosine/audit/${id}`)
  return response.data
}

export function useMenemosineDetailQuery(id) {
  const query = useQuery({
    queryKey: ['menemosineAudit', id],
    queryFn: () => fetchMenemosineAuditDetail(id),
    enabled: Boolean(id),
  })

  return {
    audit: query.data ?? null,
    versions: query.data?.versions ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}

export default useMenemosineQuery
